import deCheckinsImage from '@/../public/_n/images/second-free-trial/de/Checkins.png';
import deMeditationImage from '@/../public/_n/images/second-free-trial/de/Courses.png';
import deDailyImage from '@/../public/_n/images/second-free-trial/de/Daily.png';
import deMovementImage from '@/../public/_n/images/second-free-trial/de/Movement.png';
import deMusicImage from '@/../public/_n/images/second-free-trial/de/Music.png';
import deSleepImage from '@/../public/_n/images/second-free-trial/de/Sleep.png';
import enCheckinsImage from '@/../public/_n/images/second-free-trial/en/Checkins.png';
import enMeditationImage from '@/../public/_n/images/second-free-trial/en/Courses.png';
import enDailyImage from '@/../public/_n/images/second-free-trial/en/Daily.png';
import enMovementImage from '@/../public/_n/images/second-free-trial/en/Movement.png';
import enMusicImage from '@/../public/_n/images/second-free-trial/en/Music.png';
import enSleepImage from '@/../public/_n/images/second-free-trial/en/Sleep.png';
import esCheckinsImage from '@/../public/_n/images/second-free-trial/es/Checkins.png';
import esMeditationImage from '@/../public/_n/images/second-free-trial/es/Courses.png';
import esDailyImage from '@/../public/_n/images/second-free-trial/es/Daily.png';
import esMusicImage from '@/../public/_n/images/second-free-trial/es/Music.png';
import esSleepImage from '@/../public/_n/images/second-free-trial/es/Sleep.png';
import frCheckinsImage from '@/../public/_n/images/second-free-trial/fr/Checkins.png';
import frMeditationImage from '@/../public/_n/images/second-free-trial/fr/Courses.png';
import frDailyImage from '@/../public/_n/images/second-free-trial/fr/Daily.png';
import frMusicImage from '@/../public/_n/images/second-free-trial/fr/Music.png';
import frSleepImage from '@/../public/_n/images/second-free-trial/fr/Sleep.png';
import jaCheckinsImage from '@/../public/_n/images/second-free-trial/ja/Checkins.png';
import jaMeditationImage from '@/../public/_n/images/second-free-trial/ja/Courses.png';
import jaDailyImage from '@/../public/_n/images/second-free-trial/ja/Daily.png';
import jaMusicImage from '@/../public/_n/images/second-free-trial/ja/Music.png';
import jaSleepImage from '@/../public/_n/images/second-free-trial/ja/Sleep.png';
import koCheckinsImage from '@/../public/_n/images/second-free-trial/ko/Checkins.png';
import koMeditationImage from '@/../public/_n/images/second-free-trial/ko/Courses.png';
import koDailyImage from '@/../public/_n/images/second-free-trial/ko/Daily.png';
import koMusicImage from '@/../public/_n/images/second-free-trial/ko/Music.png';
import koSleepImage from '@/../public/_n/images/second-free-trial/ko/Sleep.png';
import ptCheckinsImage from '@/../public/_n/images/second-free-trial/pt/Checkins.png';
import ptMeditationImage from '@/../public/_n/images/second-free-trial/pt/Courses.png';
import ptDailyImage from '@/../public/_n/images/second-free-trial/pt/Daily.png';
import ptMusicImage from '@/../public/_n/images/second-free-trial/pt/Music.png';
import ptSleepImage from '@/../public/_n/images/second-free-trial/pt/Sleep.png';
import { CALM_LANGUAGES, CalmLanguage } from '@/utils/language';
import BodyLeanOutline from 'icons/body-outline.svg';
import MusicOutline from 'icons/music-outline.svg';
import PencilOutline from 'icons/pencil-outline.svg';
import SleepOutline from 'icons/sleep-outline.svg';
import StreakOutline from 'icons/streak-multiple-outline.svg';
import SunsetOutline from 'icons/sunset-outline.svg';

import { featuresMessages as messages } from '../messages';
import type { FeatureName, StaticImageData } from './types';

export const localeImages: Record<
	CalmLanguage,
	{
		[k in Exclude<FeatureName, 'movement'>]: StaticImageData | string;
	} & {
		movement?: StaticImageData | string;
	}
> = {
	en: {
		dailySeries: enDailyImage,
		meditation: enMeditationImage,
		sleep: enSleepImage,
		musicAndSoundscapes: enMusicImage,
		movement: enMovementImage,
		checkIns: enCheckinsImage,
	},
	fr: {
		dailySeries: frDailyImage,
		meditation: frMeditationImage,
		sleep: frSleepImage,
		musicAndSoundscapes: frMusicImage,
		checkIns: frCheckinsImage,
	},
	ja: {
		dailySeries: jaDailyImage,
		meditation: jaMeditationImage,
		sleep: jaSleepImage,
		musicAndSoundscapes: jaMusicImage,
		checkIns: jaCheckinsImage,
	},
	de: {
		dailySeries: deDailyImage,
		meditation: deMeditationImage,
		sleep: deSleepImage,
		musicAndSoundscapes: deMusicImage,
		movement: deMovementImage,
		checkIns: deCheckinsImage,
	},
	es: {
		dailySeries: esDailyImage,
		meditation: esMeditationImage,
		sleep: esSleepImage,
		musicAndSoundscapes: esMusicImage,
		checkIns: esCheckinsImage,
	},
	pt: {
		dailySeries: ptDailyImage,
		meditation: ptMeditationImage,
		sleep: ptSleepImage,
		musicAndSoundscapes: ptMusicImage,
		checkIns: ptCheckinsImage,
	},
	ko: {
		dailySeries: koDailyImage,
		meditation: koMeditationImage,
		sleep: koSleepImage,
		musicAndSoundscapes: koMusicImage,
		checkIns: koCheckinsImage,
	},
	it: {
		dailySeries: enDailyImage,
		meditation: enMeditationImage,
		sleep: enSleepImage,
		musicAndSoundscapes: enMusicImage,
		movement: enMovementImage,
		checkIns: enCheckinsImage,
	},
	pl: {
		dailySeries: enDailyImage,
		meditation: enMeditationImage,
		sleep: enSleepImage,
		musicAndSoundscapes: enMusicImage,
		movement: enMovementImage,
		checkIns: enCheckinsImage,
	},
	zh: {
		dailySeries: enDailyImage,
		meditation: enMeditationImage,
		sleep: enSleepImage,
		musicAndSoundscapes: enMusicImage,
		movement: enMovementImage,
		checkIns: enCheckinsImage,
	},
} as const;

const data = {
	dailySeries: {
		icon: StreakOutline,
		buttonText: messages.feature1ButtonText,
		label: messages.feature1Label,
		body: messages.feature1Body,
		supportedLocales: CALM_LANGUAGES,
	},
	meditation: {
		icon: SunsetOutline,
		buttonText: messages.feature2ButtonText,
		label: messages.feature2Label,
		body: messages.feature2Body,
		supportedLocales: CALM_LANGUAGES,
	},
	sleep: {
		icon: SleepOutline,
		buttonText: messages.feature3ButtonText,
		label: messages.feature3Label,
		body: messages.feature3Body,
		supportedLocales: CALM_LANGUAGES,
	},
	musicAndSoundscapes: {
		icon: MusicOutline,
		buttonText: messages.feature4ButtonText,
		label: messages.feature4Label,
		body: messages.feature4Body,
		supportedLocales: CALM_LANGUAGES,
	},
	movement: {
		icon: BodyLeanOutline,
		buttonText: messages.feature5ButtonText,
		label: messages.feature5Label,
		body: messages.feature5Body,
		supportedLocales: ['en', 'de', 'fr'],
	},
	checkIns: {
		icon: PencilOutline,
		buttonText: messages.feature6ButtonText,
		label: messages.feature6Label,
		body: messages.feature6Body,
		supportedLocales: CALM_LANGUAGES,
	},
} as const;

export default data;
